import { useMemo } from 'react';
import { Bets } from '../../../config/bets';
import { useMWStateSlice } from '../../../store/slices/mwState/selectors';
import { useCoreSelector } from '@pp/core';


export const useMegaWinStatus = (betSpot: Bets): boolean => {
  const gameResult = useMWStateSlice.getGameResult();
  const gameStatus = useCoreSelector((state) => state.gameState.currentStatus);

  return useMemo((): boolean => {
    return (gameStatus === 'MEGA_WIN') && (gameResult?.betSpot === betSpot);
  }, [gameResult, betSpot]);
};
